import { c as _c } from "react/compiler-runtime";
import { useViewPort } from "@website/hooks/viewport";
import { isChannel } from "@website/utils/channel/helpers";
import { Header } from "@website/widget/header";
import { FC } from "react";
import { useHeaderWrapper } from "./header-wrapper.hook";
export type HeaderWrapperPropertiesType = {
  showAuth?: boolean;
};
export const HeaderWrapper: FC<HeaderWrapperPropertiesType> = () => {
  const $ = _c(5);
  const {
    headerProperties,
    scrolled
  } = useHeaderWrapper();
  const {
    isDesktop
  } = useViewPort();
  if (isDesktop && !isChannel(["jek"])) {
    const t0 = `elevation-0 fixed top-0 z-30 h-auto w-full ${scrolled ? "elevation-4" : ""}`;
    let t1;
    if ($[0] !== headerProperties) {
      t1 = <Header {...headerProperties} />;
      $[0] = headerProperties;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
      t2 = <div className="relative h-16 w-full"><div className={t0}>{t1}</div></div>;
      $[2] = t0;
      $[3] = t1;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  return null;
};